import {
  TextField,
  useTranslate,
  FunctionField,
  DateField,
  ArrayField,
  SingleFieldList,
  ChipField
} from "react-admin";
import * as User from "providers/user";
import ListDotsActions from "./ListDotsActions";
import { Link } from "react-router-dom";
import { ListItemButton, Theme, useMediaQuery } from "@mui/material";
import CustomList from "./CustomList";
import CustomDataGrid from "./CustomDataGrid";
import { EmptyMenuIcon } from "assets/Icons";
import { CustomButton } from "./CustomButton";

export default function MenuList() {
  const { user, permissions } = User.useUser();
  const translate = useTranslate();
  const isSmall = useMediaQuery<Theme>("(max-width:800px)");

  const filter = {
    company_id: permissions.isArtist
      ? user?.joined_company_id
      : permissions.companyId
  };

  return (
    <CustomList
      filter={filter}
      title={translate("pagenames.menus")}
      emptyIcon={<EmptyMenuIcon />}
      emptyTitle={translate("empty_list.no_menus_yet")}
      createButtonText={translate("empty_list.add_a_menu")}
      emptyListCreateSubtitle={translate("empty_list.do_you_want_to_add_one")}
      sort={{ field: "name", order: "ASC" }}
    >
      <CustomDataGrid bulkActionButtons={false} guideId="menu-list-table">
        <TextField
          source="name"
          label={translate("common.name")}
          data-label={translate("common.name") + ":"}
          sx={{ marginTop: "6px" }}
        />
        <DateField
          label={translate("common.created_at")}
          source="created_at"
          data-label={translate("common.created_at") + ":"}
        />
        <DateField
          label={translate("common.updated_at")}
          source="updated_at"
          data-label={translate("common.updated_at") + ":"}
        />
        {!isSmall && (
          <ArrayField
            source="locations"
            label={translate("common.locations")}
            sortable={false}
          >
            <SingleFieldList linkType={false}>
              <ChipField source="name" />
            </SingleFieldList>
          </ArrayField>
        )}
        {!isSmall && !permissions.isArtist && (
          <FunctionField
            render={(record: any) => (
              <ListDotsActions>
                <Link to={`/dashboard/Menu/${record?.id}`}>
                  <ListItemButton
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      "& .MuiListItemButton-root": {
                        fontSize: "14px",
                        fontFamily: "Inter"
                      }
                    }}
                  >
                    {translate("common.edit")}
                  </ListItemButton>
                </Link>
              </ListDotsActions>
            )}
          />
        )}
        {isSmall && (
          <FunctionField
            render={(record: any) => (
              <Link
                to={`/dashboard/Menu/${record?.id}/show`}
                style={{
                  width: "100%",
                  marginBottom: "10px"
                }}
              >
                <CustomButton
                  variant="secondary"
                  text={translate("common.view_details")}
                  sx={{ width: "100%" }}
                />
              </Link>
            )}
          />
        )}
      </CustomDataGrid>
    </CustomList>
  );
}
